import styles from './StepBar.module.scss'
import React from 'react'
import classNames from 'classnames'
import { useTranslation } from 'next-i18next'

type Props = {
  stepLabel?: string,
  items: StepBarItemProps[],
  onClick: (name: string) => void
}

type StepBarItemProps = {
  name: string,
  active: boolean
  label: string
  step?: string,
  stepLabel?: string,
  icon?: React.FunctionComponent<any>,
  onClick?: (name: string) => void
}

const StepBarItem = (props: StepBarItemProps) => {
  const IconComponent = props.icon as React.ElementType
  const { t } = useTranslation('common')

  const onClick = () => {
    if (props.onClick) {
      props.onClick(props.name)
    }
  }

  return (
    <div className={classNames(styles.item, {[styles.active]: props.active})} onClick={onClick}>
      {props.icon && (
        <IconComponent
          className={styles.icon}
        />
      )}
      <div>
        <div className={styles.step}>{props.stepLabel || t('step')} {props.step}</div>
        <div>{props.label}</div>
      </div>
    </div>
  )
}


const StepBar = (props: Props) => {
  return (
    <div className={styles.component}>
      {props.items.map((item, index) => (
        <StepBarItem
          stepLabel={props.stepLabel}
          step={props.stepLabel ? '' : (index + 1).toString()}
          key={item.name}
          name={item.name}
          active={item.active}
          label={item.label}
          icon={item.icon}
          onClick={props.onClick}
        />
      ))}
    </div>
  )
}

export default StepBar